import CodeMirror from 'codemirror';

const toWordRegex = (tokens) => new RegExp(`\\b(?:${tokens.join('|')})\\b`);

const KEYWORDS = [
  'set',
  'request',
  'delete',
  'edit',
  'show',
  'protect:?',
  'inactive:',
  'unprotect',
  'deactivate',
  'activate'
];
const TOP_LEVEL_BLOCKS = [
  'system',
  'forwarding-options',
  'routing-options',
  'routing-instances',
  'logical-systems',
  'vlans',
  'bridge-domains',
  'dynamic-profiles',
  'interfaces',
  'snmp',
  'poe',
  'ethernet-switching-options',
  'security'
];
const ADDITIONAL_BLOCKS_GROUP_ONE = [
  'policy-options',
  'protocols',
  'chassis',
  'firewall',
  'applications',
  'multi-chassis',
  'redundant-power-system',
  'version',
  'services',
  'virtual-chassis',
  'event-options',
  'class-of-service',
  'access'
];
const ADDITIONAL_BLOCKS_GROUP_TWO = [
  'accounting-options',
  'diameter',
  'fabric',
  'multicast-snooping-options',
  'switch-options',
  'wlan',
  'smtp',
  'schedulers'
];
const GROUP_DIRECTIVES = [
  'apply-groups',
  'groups',
  'access-profile',
  'routing-instances',
  'jsrc-partition',
  'logical-systems'
];
const DENY_KEYWORDS = ['deny', 'discard', 'reject'];
const PERMIT_KEYWORDS = ['accept', 'permit'];

CodeMirror.defineSimpleMode('junos', {
  start: [
    { regex: /\/\*/, token: 'comment', next: 'comment' },
    { regex: /#.*/, token: 'comment' },
    { regex: toWordRegex(KEYWORDS), token: 'keyword' },
    { regex: toWordRegex(TOP_LEVEL_BLOCKS), token: 'def' },
    { regex: toWordRegex(ADDITIONAL_BLOCKS_GROUP_ONE), token: 'def' },
    { regex: toWordRegex(ADDITIONAL_BLOCKS_GROUP_TWO), token: 'def' },
    { regex: toWordRegex(GROUP_DIRECTIVES), token: 'def' },
    { regex: toWordRegex(DENY_KEYWORDS), token: 'error' },
    { regex: toWordRegex(PERMIT_KEYWORDS), token: 'atom' },
    {
      regex:
        /\b(?:(?:ge|et|so|fe|gr|xe|lt|vt|si|sp)-\d+\/\d+\/\d+(?:\.\d+)?|(?:st|lo|me|vme|ae|reth)\d{1,3}(?:\.\d+)?|irb|vlan)\b/,
      token: 'variable-2'
    },
    { regex: /\b(?:\d{1,3}\.){3}\d{1,3}(?:\/\d{1,2})?\b/, token: 'number' },
    { regex: /\b(?:[0-9A-Fa-f]{2}[:-]){5}[0-9A-Fa-f]{2}\b/, token: 'number' },
    { regex: /\b(?:[0-9a-fA-F]{1,4}:){2,7}[0-9a-fA-F]{1,4}(?:\/\d{1,3})?\b/, token: 'number' },
    { regex: /::(?:[0-9a-fA-F]{1,4}:)*[0-9a-fA-F]{1,4}(?:\/\d{1,3})?\b/, token: 'number' },
    { regex: /\b(?:https?|scp|s?ftp|tftp):\/\/[^\s]+/, token: 'link' },
    { regex: /\b(?:[\w\d_-]+\.)?(?:inet6?|mpls|inetflow|iso|bgp\.l[23]vpn)\.\d{1,2}\b/, token: 'link' },
    { regex: /"(?:[^\\"]|\\.)*"?/, token: 'string' },
    { regex: /'(?:[^\\']|\\.)*'?/, token: 'string' },
    { regex: /\bdescription\s+[^\s;]+/, token: 'string' },
    { regex: /[{}[\]();]/, token: 'bracket' }
  ],
  comment: [
    { regex: /.*?\*\//, token: 'comment', next: 'start' },
    { regex: /.*/, token: 'comment' }
  ],
  meta: {
    lineComment: '#'
  }
});

CodeMirror.defineMIME('text/x-junos', 'junos');
